<template>
  <!-- 通用的线型数据排行榜，只能固定的显示几个数据 -->
  <div class="simple-rank" :style="{'color': fontColor}">
    <yq-empty description="正在加载中" v-if="rankList.length === 0" style="padding: 0;opacity: .3"/>
    <div class="rank-item" v-for="(item, i) in rankList" :key="i">
      <div class="rank-name">
        <div class="name">{{item.itemName}}</div>
        <div class="count">{{item.count}}{{unitName}}</div>
      </div>
      <div class="rank-building" :style="{'width': item.percent + '%', backgroundColor: rankColorList[i%rankColorList.length]}"></div>
    </div>
  </div>
</template>

<script>

import {useRoute, useRouter} from "vue-router";

export default {
  props: {
    // 数据格式：[{buildingName: "xxx", count: 10}]
    rankList: {default: () => [{itemName: "宜金高速", count: 15},{itemName: "江安一号工地", count: 10},{itemName: "新安二号工地", count: 5},{itemName: "新安三号工地", count: 3},{itemName: "乐资工地01", count: 2}]},
    rankColorList: {default: () => ["#bdeef0","#63ffff","#3be3ff","#0091b7","#02495b"]},
    fontColor: {default: "#FFF"},
    unitName: {default: ""},
  },
  setup() {
    return {
      router: useRouter(),
      route: useRoute(),
    }
  },
  name: "SimpleRank",
  components: {
  },
  data() {
    return {

    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      // 找到最大值，计算比例
      if (!this.rankList.length) {
        return;
      }
      let max = this.rankList[0].count;
      for (let i = 0; i < this.rankList.length; i++) {
        if (this.rankList[i].count > max) {
          max = this.rankList[i].count;
        }
      }
      this.rankList.forEach(item => {
        item.percent = item.count / max * 100;
      })
    }
  }
};
</script>

<style lang="scss" scoped>
.simple-rank{
  //margin-bottom: 20px;
  .rank-item{
    .rank-name{
      display: flex;
      justify-content: space-between;
      .name{
        font-size: 14px;
        margin-bottom: 0;
        //color: #FFF;
      }
    }
    .rank-building{
      height: 5px;
      border-radius: 8px;
      margin-bottom: 10px;
    }
  }
}
</style>